<template>
  <div class="cb-banner-area">
    <div class="banner-inr flex-btw">
      <div class="left-txt">
        <span>{{ t('upgrade_plan') }}</span>
        <div class="grd-txt-wrap">
          <p>{{ t('credit') }}</p>
          <p>{{ t('banner_max_discount') }}</p>
        </div>
        <div class="aw-txt">
          <span>{{ t('banner_go_to') }}</span>
          <IconArrow />
        </div>
        <!-- <p>{{ t('credit_discount') }}</p> -->
      </div>

      <div class="right-obj">
        <img src="/public/images/dashboard/plan-keyvisual.svg" alt="" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconArrow from '@/components/icons/IconArrow.vue';

const { t } = useI18n();
</script>

<style scoped lang="scss">
.cb-banner-area {
  position: relative;
  background: $color-gray-900;
  border-radius: $size-m;
  padding: 1.5rem 1.25rem;
  margin: 0.5rem 0 2.5rem;
  cursor: pointer;
  .banner-inr {
    position: relative;
    width: 100%;
    z-index: 1;
    .left-txt {
      color: #fff;
      font-weight: 600;
      span {
        font-size: $font-size-psmall;
      }
      .grd-txt-wrap {
        display: flex;
        align-items: center;
        gap: $size-xs;
        p {
          font-weight: 600;
          color: #fff;
          font-size: 1.25rem;
          &:nth-child(2) {
            background: linear-gradient(
              90deg,
              rgba(191, 178, 255, 1) 0%,
              rgba(184, 225, 255, 1) 50%,
              rgba(229, 247, 233, 1) 100%
            );
            background-size: 200% 200%;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            animation: gradient-move 5s ease infinite;
          }
        }
      }
      .aw-txt {
        display: flex;
        align-items: center;
        margin-top: $size-s;
        svg {
          color: #fff;
          transform: rotate(90deg);
        }
      }
    }
    .right-obj {
      width: 160px;
      position: absolute;
      right: 0;
      top: -10px;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }
}

@keyframes gradient-move {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
